export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const USER_LIST = 'USER_LIST';

export default {
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	USER_LIST
};
